import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { environment } from 'src/environments/environment';
import { CacheService } from '../cache.service';
import { filter, Observable } from 'rxjs';
import {
  OrganizationResult,
  OrganizationSettingsResult,
  OrganizationSMSPlanResult,
  OrganizationStartupSettingsResult,
} from 'src/app/shared/models/agency-mgmt/manager.service.model';
import { Events } from 'src/app/shared/constants/events.constant';
import { User } from 'src/app/communications/models/contacts/user-list.model';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService extends BaseService {
  private readonly urlPrefix = `${environment.agencyMgmt.urlPrefix}/organization`;
  private readonly urlPrefixFortradee = `${environment.tradeMgmt.urlPrefix}/tradee`;

  constructor(http: HttpClient, private cacheService: CacheService) {
    super(http);
  }

  getSettings(
    currentVersion: string = '',
    forceRefresh: boolean = false
  ): Observable<OrganizationSettingsResult> {
    const cacheKey = `${this.constructor.name}_${this.getSettings.name}`;
    if (forceRefresh) {
      this.cacheService.clearOrganizationSettingCache(cacheKey);
    }
    return this.cacheService.get(
      cacheKey,
      currentVersion,
      this.get<OrganizationSettingsResult>(`${this.urlPrefix}/settings`),
      [Events.OrganizationSettingsChangedEvent, Events.JobStatusChangedEvent]
    );

    // return this.get<OrganizationSettingsResult>(`${this.urlPrefix}/settings`);
  }

  getStartupSettings(): Observable<OrganizationStartupSettingsResult> {
    return this.cacheService
      .get(
        `${this.constructor.name}_${this.getStartupSettings.name}`,
        `noversion`,
        this.get<OrganizationStartupSettingsResult>(
          `${this.urlPrefix}/settings/startup`
        ),
        []
      )
  }

  getList(): Observable<OrganizationResult[]> {
    return this.cacheService.get(
      `${this.constructor.name}_${this.getList.name}`,
      `noversion`,
      this.get<OrganizationResult[]>(`${this.urlPrefix}/list`),
      []
    );
  }

  getUsers(result: any) {
    if (result.exportPDF != true)
      return this.get<any>(
        `${this.urlPrefix}/users${this.queryParams(result)}`
      );

    return this.getBlob(`${this.urlPrefix}/users${this.queryParams(result)}`);
  }

  inviteUsers(userList: User[]) {
    let command: any = { inviteUsers: userList };
    return this.post<User[]>(`${this.urlPrefix}/user-invitations`, command);
  }

  getUserDetails(request) {
    return this.get<any>(`${this.urlPrefix}/user${this.queryParams(request)}`);
  }

  updateCustomInvitationNote(request: any) {
    let command: any = {
      customUserId: request.customUserId,
      userId: request.userId,
      userType: request.userType,
      note: request.note,
    };
    return this.patch(`${this.urlPrefix}/save-invitation-note`, command);
  }

  syncTradeeSelected(request: any) {
    let command: any = { UserId: request.userId, IsSync: request.isSync };
    return this.put(`${this.urlPrefixFortradee}/save-sync-tradee`, command);
  }

  getSMSPlan() {
    return this.get<OrganizationSMSPlanResult>(`${this.urlPrefix}/sms-plan`);
  }
  getRecommendationEnabledStatus() {
    return this.get<boolean>(`${this.urlPrefix}/recommendation-enabled-status`);
  }
}
